// A simple regexp to catch most cases.
const emailReg = /^\S+@\S+\.\S+$/;

/**
 * Simple validation of email addresses.
 * @param email The email address to validate
 */
const validateEmail = (email: string | string[]): boolean => {
  if (typeof email !== 'string') {
    return email.reduce<boolean>((p, n) => p && validateEmail(n), true);
  }
  if (!email) return true;
  const parts = email.split('@');
  if (parts.length !== 2) return false;

  const account = parts[0];
  const address = parts[1];

  if (account.length > 64) return false;
  else if (address.length > 255) return false;

  var domainParts = address.split('.');
  if (
    domainParts.some(function (part) {
      return part.length > 63;
    })
  )
    return false;

  if (!emailReg.test(email)) return false;

  return true;
};

export default validateEmail;
